<template>

</template>

<script>
    export default {
        name: 'Franchisee',
        data () {
            return {}
        },
        mounted () {
            // получаем список франшиз пользователя
            this.axios.get('')
                .then(response => {
                    console.log(response)
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }
</script>


// WEBPACK FOOTER //
// Franchisee.vue?a67c2d28